const NoRoute = () => <>404</>

export default NoRoute
